module.exports = __webpack_public_path__ + "static/media/blog_51.9efae8ea.webp";